export interface PayloadViewerData {
  payload: any;
  hasNext?: boolean;
  hasPrev?: boolean;
}

export enum PayloadViewerOrder {
  PREV = 'prev',
  NEXT = 'next'
}
